/* tslint:disable */
/* eslint-disable */
/**
 * Legalscape REST API
 * Internal API for use from web
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetPracticeAreaSnippetsResponse } from '../model';
/**
 * CommentsApi - axios parameter creator
 * @export
 */
export const CommentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 指定したプラクティスエリアのニュース、タグ、タグと紐付いた文献（コメント付き書籍、パブコメ、ガイドライン、法令）を取得する。
         * @summary プラクティスエリアの各種リソースのスニペットを取得する。
         * @param {string} id プラクティスエリア ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticeAreaSnippets: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPracticeAreaSnippets', 'id', id)
            const localVarPath = `/practice-areas/{id}/snippets`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommentsApi - functional programming interface
 * @export
 */
export const CommentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 指定したプラクティスエリアのニュース、タグ、タグと紐付いた文献（コメント付き書籍、パブコメ、ガイドライン、法令）を取得する。
         * @summary プラクティスエリアの各種リソースのスニペットを取得する。
         * @param {string} id プラクティスエリア ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPracticeAreaSnippets(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPracticeAreaSnippetsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPracticeAreaSnippets(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CommentsApi - factory interface
 * @export
 */
export const CommentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommentsApiFp(configuration)
    return {
        /**
         * 指定したプラクティスエリアのニュース、タグ、タグと紐付いた文献（コメント付き書籍、パブコメ、ガイドライン、法令）を取得する。
         * @summary プラクティスエリアの各種リソースのスニペットを取得する。
         * @param {string} id プラクティスエリア ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticeAreaSnippets(id: string, options?: any): AxiosPromise<GetPracticeAreaSnippetsResponse> {
            return localVarFp.getPracticeAreaSnippets(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommentsApi - interface
 * @export
 * @interface CommentsApi
 */
export interface CommentsApiInterface {
    /**
     * 指定したプラクティスエリアのニュース、タグ、タグと紐付いた文献（コメント付き書籍、パブコメ、ガイドライン、法令）を取得する。
     * @summary プラクティスエリアの各種リソースのスニペットを取得する。
     * @param {string} id プラクティスエリア ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApiInterface
     */
    getPracticeAreaSnippets(id: string, options?: AxiosRequestConfig): AxiosPromise<GetPracticeAreaSnippetsResponse>;

}

/**
 * CommentsApi - object-oriented interface
 * @export
 * @class CommentsApi
 * @extends {BaseAPI}
 */
export class CommentsApi extends BaseAPI implements CommentsApiInterface {
    /**
     * 指定したプラクティスエリアのニュース、タグ、タグと紐付いた文献（コメント付き書籍、パブコメ、ガイドライン、法令）を取得する。
     * @summary プラクティスエリアの各種リソースのスニペットを取得する。
     * @param {string} id プラクティスエリア ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public getPracticeAreaSnippets(id: string, options?: AxiosRequestConfig) {
        return CommentsApiFp(this.configuration).getPracticeAreaSnippets(id, options).then((request) => request(this.axios, this.basePath));
    }
}
